/// <summary>
/// 運用設定画面のタブコンポーネントの基底クラス
/// </summary>
import { Options, Vue } from 'vue-class-component';

export default class AbstractSettingTab extends Vue {
    protected strOpenDialog = "";         // 開いているダイアログ

    // 起動時の処理
    public created(): void {
        this.strOpenDialog = "";
    }

    // タブボタン押下
    onTabClick(strClickedTab: string): void {
        // 親に通知
        this.$emit("requestChangeTab", strClickedTab);
    }

    // 設定ボタン押下
    public onBtnSetting(strID: string): void {
        // ダイアログ切り替えは具象クラス
        this.strOpenDialog = strID;
    }

    // 設定画面を閉じた通知
    public onCloseDialog(): void {
        this.strOpenDialog = "";
    }
}
